import script from "./StepSocial.vue?vue&type=script&setup=true&lang=js"
export * from "./StepSocial.vue?vue&type=script&setup=true&lang=js"

import "./StepSocial.vue?vue&type=style&index=0&id=d1a77c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a77c54"]])

export default __exports__